import { render, staticRenderFns } from "./WorkshopTraffic.vue?vue&type=template&id=31cb44aa"
import script from "./WorkshopTraffic.vue?vue&type=script&lang=js"
export * from "./WorkshopTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports